import { render, staticRenderFns } from "./CompleteRegistration.vue?vue&type=template&id=559b62bd&scoped=true&"
import script from "./CompleteRegistration.vue?vue&type=script&lang=js&"
export * from "./CompleteRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CompleteRegistration.vue?vue&type=style&index=0&id=559b62bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559b62bd",
  null
  
)

export default component.exports